import { Cartesian3, Cartographic, Color, ConstantProperty, HeadingPitchRange, PinBuilder, VerticalOrigin, } from "cesium";
export class PinManager {
    _pixelRange;
    _minimumClusterSize;
    _clusteringEnabled;
    _pin5;
    _pin10;
    _pin15;
    _pin20;
    _pin25;
    _pinBuilder = new PinBuilder();
    _pinMap = new Map();
    _viewer;
    constructor(viewer) {
        this._pixelRange = 10;
        this._minimumClusterSize = 5;
        this._clusteringEnabled = false;
        this._viewer = viewer;
        viewer.dataSourceDisplay.defaultDataSource.clustering.enabled =
            this._clusteringEnabled;
        viewer.dataSourceDisplay.defaultDataSource.clustering.pixelRange =
            this._pixelRange;
        viewer.dataSourceDisplay.defaultDataSource.clustering.minimumClusterSize =
            this._minimumClusterSize;
        const color = Color.fromCssColorString("#ffffff");
        this._pin5 = this._pinBuilder.fromText("5+", color, 48).toDataURL();
        this._pin10 = this._pinBuilder.fromText("10+", color, 48).toDataURL();
        this._pin15 = this._pinBuilder.fromText("15+", color, 48).toDataURL();
        this._pin20 = this._pinBuilder.fromText("20+", color, 48).toDataURL();
        this._pin25 = this._pinBuilder.fromText("25+", color, 48).toDataURL();
        viewer.dataSourceDisplay.defaultDataSource.clustering.clusterEvent.addEventListener(this.updatePinClusterData.bind(this));
    }
    getPin(id) {
        return this._pinMap.get(id);
    }
    toggleClustering(viewer, status) {
        viewer.dataSourceDisplay.defaultDataSource.clustering.enabled = status;
    }
    addPin(viewer, longitude, latitude, cssColorString) {
        if (this._pinMap.size === 0) {
            this.toggleClustering(viewer, true);
        }
        const pos = new Cartographic(longitude, latitude);
        pos.height = viewer.scene.globe.getHeight(pos);
        const groundPos = Cartesian3.fromDegrees(pos.longitude, pos.latitude, pos.height);
        const entity = this.createPinEntity(viewer, groundPos, cssColorString);
        this._pinMap.set(entity.id, entity);
        // viewer.scene.requestRender();
        return entity.id;
    }
    removePin(viewer, id) {
        const entity = this._pinMap.get(id);
        if (entity) {
            viewer.entities.remove(entity);
            this._pinMap.delete(id);
            if (this._pinMap.size === 0) {
                this.toggleClustering(viewer, false);
            }
            return true;
        }
        // viewer.scene.requestRender();
        return false;
    }
    createPinEntity(viewer, position, cssColorString) {
        if (!position) {
            return;
        }
        const pinEntity = viewer.entities.add({
            name: "Pin",
            position: position,
            billboard: {
                image: this._pinBuilder.fromColor(Color.fromCssColorString(cssColorString), 48),
                verticalOrigin: VerticalOrigin.BOTTOM,
            },
        });
        return pinEntity;
    }
    updatePinClusterData(clusteredEntities, cluster) {
        cluster.label.show = false;
        cluster.billboard.show = true;
        cluster.billboard.id = cluster.label.id;
        cluster.billboard.verticalOrigin = VerticalOrigin.BOTTOM;
        switch (true) {
            case clusteredEntities.length >= 25:
                cluster.billboard.image = this._pin25;
                break;
            case clusteredEntities.length >= 20:
                cluster.billboard.image = this._pin20;
                break;
            case clusteredEntities.length >= 15:
                cluster.billboard.image = this._pin15;
                break;
            case clusteredEntities.length >= 10:
                cluster.billboard.image = this._pin10;
                break;
            case clusteredEntities.length >= 5:
                cluster.billboard.image = this._pin5;
                break;
        }
    }
    updatePin(id, { color, highlight }) {
        const entity = this.getPin(id);
        if (entity) {
            const scale = highlight ? 1.5 : 1.0;
            entity.billboard.color = new ConstantProperty(Color.fromCssColorString(color));
            entity.billboard.scale = new ConstantProperty(scale);
            // this._viewer.scene.requestRender();
            return true;
        }
        return false;
    }
    focusPin(id) {
        const entity = this.getPin(id);
        if (entity) {
            this._viewer.flyTo(entity, {
                offset: new HeadingPitchRange(0, -Math.PI / 8, 2900),
            });
            // this._viewer.scene.requestRender();
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=PinManager.js.map